import type { LocationPayload } from './location';

export enum OnboardingRoute {
  Base = '/auth/onboarding',
  Company = '/auth/onboarding/company',
  Location = '/auth/onboarding/location',
  Features = '/auth/onboarding/features',
  Logo = '/auth/onboarding/logo',
}

export interface OnboardingOption {
  value: string;
  labelKey: string;
}

/**
 * A location of the onboarding Locations step. Each has its country,
 * province (CA, US, AU, GB, FR) and city (JP, 2026-10-04); `branchId` marks
 * the default branch the Company step already created.
 */
export interface OnboardingLocation extends LocationPayload {
  name: string;
  isDefault: boolean;
  branchId?: string;
}

export interface OnboardingFeature {
  id: string;
  // Emoji rendered on the module's white icon tile.
  icon: string;
  titleKey: string;
  descKey: string;
  // Featured modules render as large cards; the rest render as list rows.
  featured?: boolean;
  // Enabled by default when the step first loads.
  defaultEnabled?: boolean;
}

// One variant per onboarding step (only 4 steps exist so far). The enum value
// doubles as the `sidebar.*` translation key segment, so the content for each
// variant lives in the `onboarding` namespace under `sidebar.<value>`.
export enum OnboardingSidebarVariant {
  Company = 'company',
  Location = 'location',
  Features = 'features',
  Logo = 'logo',
}

export interface SidebarVariantConfig {
  // Translation key prefix, e.g. `sidebar.company`.
  keyPrefix: string;
}

export const SIDEBAR_VARIANTS: Record<
  OnboardingSidebarVariant,
  SidebarVariantConfig
> = {
  [OnboardingSidebarVariant.Company]: {
    keyPrefix: `sidebar.${OnboardingSidebarVariant.Company}`,
  },
  [OnboardingSidebarVariant.Location]: {
    keyPrefix: `sidebar.${OnboardingSidebarVariant.Location}`,
  },
  [OnboardingSidebarVariant.Features]: {
    keyPrefix: `sidebar.${OnboardingSidebarVariant.Features}`,
  },
  [OnboardingSidebarVariant.Logo]: {
    keyPrefix: `sidebar.${OnboardingSidebarVariant.Logo}`,
  },
};
